import { Box, Typography } from '@mui/material';

export default function VendorInitiatedForm() {
  return (
    <Box mt={5} padding={1}>
      <Typography variant='body2' color='text.secondary'>
        <strong>Note: </strong>You cannot create this integration manually because it’s a{' '}
        <strong>vendor-initiated onboarding</strong>. Please contact your vendor or integration provider to complete the
        setup process.
      </Typography>
    </Box>
  );
}
